var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"bm-view",attrs:{"href":"javascript:void(0)","role":"button","title":'查看地图：' + _vm.title},on:{"click":function($event){$event.preventDefault();return _vm.onOpen.apply(null, arguments)}}},[_c('img',{staticClass:"bm-view__img",attrs:{"src":_vm.mapImg,"alt":_vm.title}})])
}
var staticRenderFns = []

export { render, staticRenderFns }